import React from 'react';
import {Route, BrowserRouter as Router, Switch} from 'react-router-dom';
import {TransitionGroup, CSSTransition} from 'react-transition-group';

import { setColor } from './components/colors.js';
import "./styles/transitionStyle.css";
import "./styles/fonts.css";
import "./fonts/completeiconlist_1/styles.css";
import './App.css';

import PagPrincipal from './components/PagPrincipal';
import RutasPagsExtra from './components/RutasPagsExtra';
import RutasPagsPersonal from "./components/RutasPagsPersonal";
import RutasVentanasGuias from "./components/RutasVentanasGuias";
import RutasPagLogin from "./components/PagLogin";
import RutasPagRegister from "./components/PagRegister";

function App() {
  setColor();
  return (
    <Router>
      <section className="route-section">
        <Route render={({location}) =>
          <TransitionGroup>
            <CSSTransition
              key={location.key}
              timeout={{enter: 300, exit: 300}}
              classNames={"fade"}
            >
              <Switch location={location}>
                <Route exact path="/" component={PagPrincipal} />
                <Route path="/extra" component={RutasPagsExtra}/>
                <Route path="/user" component={RutasPagsPersonal}/>
                <Route path="/window" component={RutasVentanasGuias}/>
                <Route path="/login" component={RutasPagLogin}/>
                <Route path="/register" component={RutasPagRegister}/>
              </Switch>
            </CSSTransition>

          </TransitionGroup>
        } />
      </section>
    </Router>
  );
}

export default App;
